/**
 * App 启动时调用的公共接口（自 App.js 原样迁出，行为不变）
 */
import { setGuestPermissions } from './permissionControl';

// 获取访客权限
export const fetchGuestPermissions = async () => {
  try {
    const response = await fetch('/api/user/guest-permissions');
    const data = await response.json();
    if (data.success) {
      setGuestPermissions(data.permissions);
      console.log('访客权限已设置:', data.permissions);
    }
  } catch (error) {
    console.error('获取访客权限失败:', error);
  }
};

// 获取公告
export const fetchAnnouncements = async () => {
  try {
    console.log('🔍 开始获取公告...');
    const response = await fetch('/api/admin/announcements/public');
    const data = await response.json();
    console.log('📋 公告API响应:', data);
    if (data.success && data.announcement) {
      // 公共API返回单个公告，将其包装成数组
      const announcement = data.announcement;
      console.log('📢 获取到公告:', announcement);
      return [announcement];
    }
  } catch (error) {
    console.error('❌ 获取公告失败:', error);
  }
  return [];
};
